import { useContext } from 'react'

import { Box } from '@mantine/core'

import { CtaBannerContext } from '../../context'
import { ListingItem } from '../ListingItem'

export const NormalGroup = () => {
  const { data } = useContext(CtaBannerContext)
  const { listing } = data
  return (
    <Box>
      {listing.map((group, index) => (
        <ListingItem banners={group.banners} key={String(index)} />
      ))}
    </Box>
  )
}
